import styled from 'styled-components';

export default styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;

  .page-content {
    flex: 1;
  }
`;
